document.addEventListener("DOMContentLoaded", () => {
  const gtmNewsletterSubmitEvent = new GtmNewsletterSubmitEvent()
  gtmNewsletterSubmitEvent.fireEventOnSubmit()
})

class GtmNewsletterSubmitEvent {
  SEND_MESSAGE_DELAY = 500
  SUBMIT_EVENT_NAME = "mailchimp.newsletter.submit"

  constructor() {
    this.subscribeButton = document.querySelector("#mc-embedded-subscribe")
    this.isFired = false
  }

  fireEventOnSubmit() {
    if (!this.subscribeButton) return

    this.subscribeButton.addEventListener("click", () => {
      if (this.isFired) return
      this.isFired = true

      setTimeout(() => {
        dataLayer.push({
          event: this.SUBMIT_EVENT_NAME,
        })
        this.isFired = false
      }, this.SEND_MESSAGE_DELAY)
    })
  }
}
